import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'
import { RelatedEntity } from '../base/RelatedEntity'
import { generateEntityId } from '../generateEntityId'
import { User } from '../user/User'

/**
 * One sender address the tenant treats as spam. Mail from a listed address arrives already
 * Cancelled; the record holds the address in its normalised comparison form and who marked it.
 */
@ObjectType()
@InputType('SpamSenderInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class SpamSender extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('spam') })
  declare _id: string

  @Field(() => String)
  @Prop({ type: String })
  address: string

  @Field(() => User, { nullable: true })
  @Prop({ type: RelatedEntity })
  markedBy?: ReturnType<() => User>
}
